module.exports = __webpack_public_path__ + "static/2016-035d54b553c1a556c76c706b3048cddd.jpg";